export default class Storage {
    static prefix() {
        return process.env.VUE_APP_LOCAL_STORAGE_PREFIX || 'com.atabix_';
    }
    static title(key) {
        return Storage.prefix() + key;
    }
    static get(key) {
        return localStorage.getItem(Storage.title(key));
    }
    static has(key) {
        return !!Storage.get(key);
    }
    static set(key, value) {
        localStorage.setItem(Storage.title(key), value);
    }
    static delete(key) {
        localStorage.removeItem(Storage.title(key));
    }
    static setWithExpiry(key, value, ttl) {
        const now = new Date();
        // `item` is an object which contains the original value
        // as well as the time when it's supposed to expire
        const item = {
            value,
            expiry: now.getTime() + ttl,
        };
        localStorage.setItem(Storage.title(key), JSON.stringify(item));
    }
    static getWithExpiry(key) {
        const itemStr = localStorage.getItem(Storage.title(key));
        // if the item doesn't exist, return null
        if (!itemStr) {
            return null;
        }
        const item = JSON.parse(itemStr);
        const now = new Date();
        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
            // If the item is expired, delete the item from storage
            // and return null
            localStorage.removeItem(Storage.title(key));
            return null;
        }
        return item.value;
    }
}
